<app-page-title [title]="'MENU.3D_CONTROLLER' | translate" [breadcrumbItems]="breadCrumbItems"/>
